import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Materials.frontend.types'

@Injectable({ providedIn: 'root' })
export class Materials_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Materials: Materials_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
